import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

let AccountUpdateOptions = {
	toggle: '[data-ajax-update=toggle]',
	target: '[data-ajax-update=target]',
	update: '[data-ajax-update=update]',
	hideClass: 'hide'
};

class AccountUpdate extends Class{

	constructor(element, options){
		super();
		this.setOptions(AccountUpdateOptions, options);
		this.setUpElements(element);
		this.setUpEvents();
	}

	setUpElements(element){
		this.element = $(element);

		this.$update = this.element.find(this.options.update).first();
		this.$screenNameWrapper = this.element.find(this.options.target).first();
		this.$toggle = this.element.find(this.options.toggle).first();

		//current name elements
		this.$currentNameRadio = this.element.find('input[type=radio]').first();

		//screen name elements
		this.$screenNameLabel = this.$update.find('label').first();
		this.$screenNameRadio = this.$update.find('input[type="radio"]');
		this.$input = this.$screenNameWrapper.find('.text').first();
	}
	
	setUpEvents(){
		this.toggleTarget();
		this.updateContent();
		this.hideContent();
	}

	updateContent(){
		var self = this;
		this.$input.on('blur', function(e){
			var $this = $(this);
			if($this.val().length){
				self.$screenNameLabel.text($this.val());
				self.$screenNameRadio.val($this.val());
				$this.parent().addClass(self.options.hideClass);
			}
		});

		this.$currentNameRadio.on('click', function(){
			self.$screenNameWrapper.addClass(self.options.hideClass);
			if(self.$screenNameLabel.text() == 'EMPTY'){
				self.disableSelection();
			}
		});
	}

	hideContent(){
		var self = this;
		this.$input.on('keypress', function(e){
			if(e.keyCode == 13){ //enter
				e.preventDefault();
				$(this).parent().addClass(self.options.hideClass);
				$(this).parent('.field').parent('.field').find('.text').focus();
			}
		});
	}

	toggleTarget(){
		var self = this;
		this.$toggle.on('click', function(e){
			e.preventDefault();
			self.$screenNameWrapper.toggleClass(self.options.hideClass);
			self.enableSelection();
		});
	}

	enableSelection(){
		var self = this;
		self.$screenNameRadio.attr({
			'disabled': false,
			'checked': true
		});
	}

	disableSelection(){
		var self = this;
		self.$screenNameRadio.attr({
			'disabled': true,
			'checked': false
		});
		self.$screenNameRadio.val('0');
	}
}

export { AccountUpdate };


// WEBPACK FOOTER //
// ./Javascript/core/classes/account/account.update.class.js